import { Protocol } from '../Protocol';

export class SupplierProtocol {
  public static readonly ALL_SUPPLIERS: string = `${Protocol.YATUNG_API_ROOT}/supplier/all`; // 取得所有供應商
  public static readonly SUPPLIER_URL: string = `${Protocol.YATUNG_API_ROOT}/supplier`; // 更新 && 建立供應商
}
